import axios from 'axios';

const Api = axios.create({
    baseURL: `http://aos.danielstandard.com/api/`
    // baseURL: 'http://192.168.0.91/avto-obuchenie/public/api/'
});

Api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')).user.token : '';

    config.params = config.params || {};

    config.headers['X-Path'] = window.location.pathname + window.location.search;

    config.headers['Authorization'] = `Bearer ${token}`;

    return config;
});

export default Api;